import { c as _c } from "react/compiler-runtime";
import { IcoDotsHorizontal16, IcoTrash16 } from '@onefootprint/icons';
import { Dialog, Dropdown, IconButton } from '@onefootprint/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { StoredBlock } from '@/features/gen-ui';
import { GenUiBlockRenderer, getSchemaVersion } from '@/features/gen-ui';
type LoadedBlock = StoredBlock & {
  content: string;
};
type BlocksPanelContentProps = {
  blocks: LoadedBlock[];
  onDelete: (block: StoredBlock) => void;
  actionsDisabled?: boolean;
  pdfTargetRef?: React.Ref<HTMLDivElement>;
};
export const BlocksPanelContent = t0 => {
  const $ = _c(24);
  const {
    blocks,
    onDelete,
    actionsDisabled,
    pdfTargetRef
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== actionsDisabled || $[1] !== blocks || $[2] !== onDelete || $[3] !== pdfTargetRef) {
    const sortedBlocks = blocks.slice().sort(_temp);
    t5 = true;
    t6 = "h-full overflow-y-auto overscroll-contain";
    t4 = "max-w-(--main-content-max-width) mx-auto w-full pb-12 md:pb-0";
    t1 = pdfTargetRef;
    t2 = "flex flex-col gap-4 pt-5 pb-8 px-4 md:px-16";
    let t7;
    if ($[10] !== actionsDisabled || $[11] !== onDelete) {
      t7 = block => <BlockCard key={block.filename} block={block} onDelete={onDelete} actionsDisabled={actionsDisabled} />;
      $[10] = actionsDisabled;
      $[11] = onDelete;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    t3 = sortedBlocks.map(t7);
    $[0] = actionsDisabled;
    $[1] = blocks;
    $[2] = onDelete;
    $[3] = pdfTargetRef;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t3) {
    t7 = <div ref={t1} className={t2}>{t3}</div>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t4 || $[18] !== t7) {
    t8 = <div className={t4}>{t7}</div>;
    $[17] = t4;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t5 || $[21] !== t6 || $[22] !== t8) {
    t9 = <section data-blocks-panel={t5} className={t6}>{t8}</section>;
    $[20] = t5;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};
type BlockCardProps = {
  block: LoadedBlock;
  onDelete?: (block: StoredBlock) => void;
  actionsDisabled?: boolean;
};
const BlockCard = t0 => {
  const $ = _c(60);
  const {
    block,
    onDelete,
    actionsDisabled
  } = t0;
  const {
    t
  } = useTranslation("investigations");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const t1 = block.filename;
  const t2 = block.title ?? "";
  let t3;
  if ($[0] !== t2) {
    t3 = <h3 className="text-label-2 text-primary truncate">{t2}</h3>;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t) {
    t4 = t(_temp2);
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== actionsDisabled || $[5] !== t4) {
    t5 = <IconButton aria-label={t4} icon={IcoDotsHorizontal16} size="compact" variant="ghost" disabled={actionsDisabled} />;
    $[4] = actionsDisabled;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== actionsDisabled || $[8] !== t5) {
    t6 = <Dropdown.Trigger asChild={true} disabled={actionsDisabled}>{t5}</Dropdown.Trigger>;
    $[7] = actionsDisabled;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setShowDeleteConfirm(true);
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t) {
    t8 = t(_temp3);
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <Dropdown.Portal><Dropdown.Content align="end"><Dropdown.Group><Dropdown.Item iconLeft={IcoTrash16} destructive={true} onSelect={t7}>{t8}</Dropdown.Item></Dropdown.Group></Dropdown.Content></Dropdown.Portal>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t6 || $[16] !== t9) {
    t10 = <Dropdown.Root>{t6}{t9}</Dropdown.Root>;
    $[15] = t6;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t3) {
    t11 = <header className="flex items-center justify-between px-2 h-10">{t3}{t10}</header>;
    $[18] = t10;
    $[19] = t3;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = block.content;
  let t13;
  if ($[21] !== block.metadata) {
    t13 = getSchemaVersion(block.metadata);
    $[21] = block.metadata;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== block.content || $[24] !== t13) {
    t14 = <div className="bg-primary rounded-md border border-tertiary overflow-hidden"><GenUiBlockRenderer content={t12} hideRootTitle={true} schemaVersion={t13} /></div>;
    $[23] = block.content;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== block.filename || $[27] !== t11 || $[28] !== t14) {
    t15 = <article id={t1} data-block-card={true} className="rounded-[10px] bg-secondary pb-1 px-1">{t11}{t14}</article>;
    $[26] = block.filename;
    $[27] = t11;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = () => setShowDeleteConfirm(false);
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t) {
    t17 = t(_temp4);
    $[31] = t;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t) {
    t18 = t(_temp5);
    $[33] = t;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== block || $[36] !== onDelete) {
    t19 = () => {
      onDelete?.(block);
      setShowDeleteConfirm(false);
    };
    $[35] = block;
    $[36] = onDelete;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t18 || $[39] !== t19) {
    t20 = {
      label: t18,
      variant: "destructive",
      onClick: t19
    };
    $[38] = t18;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t) {
    t21 = t(_temp6);
    $[41] = t;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = () => setShowDeleteConfirm(false);
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== t21) {
    t23 = {
      label: t21,
      onClick: t22
    };
    $[44] = t21;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  const t24 = block.title ?? "this block";
  let t25;
  if ($[46] !== t || $[47] !== t24) {
    t25 = t(_temp7, {
      title: t24
    });
    $[46] = t;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== t25) {
    t26 = <p className="text-body-2 text-secondary">{t25}</p>;
    $[49] = t25;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  if ($[51] !== showDeleteConfirm || $[52] !== t17 || $[53] !== t20 || $[54] !== t23 || $[55] !== t26) {
    t27 = <Dialog open={showDeleteConfirm} onClose={t16} title={t17} isConfirmation={true} size="compact" primaryButton={t20} secondaryButton={t23}>{t26}</Dialog>;
    $[51] = showDeleteConfirm;
    $[52] = t17;
    $[53] = t20;
    $[54] = t23;
    $[55] = t26;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== t15 || $[58] !== t27) {
    t28 = <>{t15}{t27}</>;
    $[57] = t15;
    $[58] = t27;
    $[59] = t28;
  } else {
    t28 = $[59];
  }
  return t28;
};
function _temp(a, b) {
  return a.filename.localeCompare(b.filename);
}
function _temp2($) {
  return $.blocksPanel.blockCard.actions.ariaLabel;
}
function _temp3($_0) {
  return $_0.blocksPanel.blockCard.actions.delete;
}
function _temp4($_1) {
  return $_1.blocksPanel.blockCard.deleteDialog.title;
}
function _temp5($_2) {
  return $_2.blocksPanel.blockCard.deleteDialog.confirm;
}
function _temp6($_3) {
  return $_3.blocksPanel.blockCard.deleteDialog.cancel;
}
function _temp7($_4) {
  return $_4.blocksPanel.blockCard.deleteDialog.description;
}